import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIDialogFooter from '../dialog/UIDialogFooter';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIPanelFooter(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIDialogFooter, Object.assign({}, rest, {
    className: classNames('private-panel__footer', className)
  }));
}
UIPanelFooter.propTypes = Object.assign({}, UIDialogFooter.propTypes, {
  children: PropTypes.node
});
UIPanelFooter.defaultProps = Object.assign({}, UIDialogFooter.defaultProps);
UIPanelFooter.displayName = 'UIPanelFooter';